jQuery(document).ready(function($){

  $('.team-bio').click(function(){
    console.log('test');
    var memberID = $(this).data('member');
    $('.team-bio').not('#' + memberID).removeClass('open');
    $('#' + memberID).toggleClass('open');
  });
  
  $('.popup').on('click', function () {
    $(this).removeClass('open')
  });

});
